/**
 * Officer entity model — ES module version of MyScripts/Entities/Officer.ts
 */

import type { OfficerData } from '@/services/api-types';

export type { OfficerData };

export function createOfficer(data?: Partial<OfficerData>): OfficerData {
  return {
    id: 0,
    officer: 0,
    officerName: '',
    dispatched: null,
    whenDispatchedChanged: null,
    enroute: null,
    whenEnrouteChanged: null,
    onScene: null,
    whenOnSceneChanged: null,
    cleared: null,
    whenClearedChanged: null,
    isPrimary: false,
    startingMileage: 0,
    endingMileage: 0,
    eventId: null,
    callCardId: null,
    isQueued: null,
    ...data,
  };
}
